import { atom, useAtom } from "jotai";

const showTranslateModalDef = atom(false);
const translateResourceInfoDef = atom<any>(null);
const useTitleTranslate = () => {
  const [showTranslateModal, setShowTranslateModal] = useAtom(showTranslateModalDef);
  const [translateResourceInfo, setTranslateResourceInfo] = useAtom(translateResourceInfoDef);

  return {
    showTranslateModal,
    setShowTranslateModal,
    translateResourceInfo,
    setTranslateResourceInfo,
  };
};

export default useTitleTranslate;
